<div class="modal-header">
  <legend class="usa-legend usa-legend--large">{{title}}</legend>
</div>
<div ng-controller="ModalCtrl" style="overflow: auto" class="modal-body">
  <form [formGroup]='frtSealOrPurchaseOrderForm'>
    <div class="grid-container">
      <div [formArrayName]="'sealOrPurchaseNumbers'">
        @for (control of frtSealOrPurchaseOrderForm.controls['sealOrPurchaseNumbers']['controls']; track control; let i = $index) {
          <div class=""
            [formGroup]="control">
            <input type="text" formControlName="text" id="{{ control.controls.id.value }}" class="usa-input">
          </div>
        }
      </div>
      <div class="grid-row margin-top-2">
        @if (!isCarrierView) {
          <button type="button" class="usa-button"
            (click)="updateSealOrPurchaseNumbers()">Update
          </button>
        }
        <button type="button" class="usa-button usa-button--secondary" (click)="cancel()">Cancel</button>
      </div>
    </div>
  </form>
</div>
